import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Create a custom storage controller that only handles the auth token
const customStorage = {
  getItem: (key: string) => {
    if (key === 'supabase.auth.token') {
      return localStorage.getItem(key);
    }
    return null;
  },
  setItem: (key: string, value: any) => {
    if (key === 'supabase.auth.token') {
      localStorage.setItem(key, value);
    }
  },
  removeItem: (key: string) => {
    if (key === 'supabase.auth.token') {
      localStorage.removeItem(key);
    }
    if (key === 'supabase.auth.token-code-verifier') {
      localStorage.removeItem(key);
    }
  },
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    storage: customStorage,
    storageKey: 'supabase.auth.token',
    detectSessionInUrl: true,
    flowType: 'implicit',
    debug: false,
    storageOptions: {
      skipRestore: false,
    },
  } as any,
})

// Clean up any existing code verifier
localStorage.removeItem('supabase.auth.token-code-verifier');

// Initialize auth state
const initializeAuth = async () => {
  try {
    if (window.location.hash) {
      return;
    }

    const existingToken = localStorage.getItem('supabase.auth.token');
    if (existingToken) {
      await supabase.auth.getSession();
    }
  } catch (error) {
    // Handle error silently or implement proper error handling if needed
  }
};

initializeAuth();

// Add event listener for storage changes
window.addEventListener('storage', (event) => {
  if (event.key === 'supabase.auth.token') {
    // Handle token change if needed
  }
});